module.exports = __webpack_public_path__ + "img/71_25.4a055dff.png";